import axios from "axios";
import { axiosDashboard, axiosApplication, axiosBackend } from "@config/axiosConfig";

export const getDashboardApplication = async (payload: any) => {
  return await axiosDashboard.post(`/listing`, { ...payload });
};

export const getDashboardEdit = async (
  access_id: number,
  application_categroy_id: number,
) => {
  return await axiosDashboard.post(
    `/application/${access_id}/${application_categroy_id}`,
  );
};

export const getDashboardDelete = async (access_id: number) => {
  return await axiosDashboard.put(`/delete-draft/${access_id}`);
};

export const getfilterApplication = async () => {
  return await axiosDashboard.get(`/stage-list`);
};

export const getLegacyApplicationList = async (applicationCode: string) => {
  return await axiosApplication.get(
    `/legacy-applications?applicationCode=${applicationCode}`,
  );
};

export const createOfflineApplication = async ({
  application_code,
  application_source,
  application_category,
}: {
  application_code: string;
  application_source: string;
  application_category: number;
}) => {
  return await axiosBackend.post(`/onboarding/offline-application`, {
    application_code,
    application_source,
    application_category,
  });
};
